import Hive from '@hiveio/hive-js';
import Axios from 'axios';
import config from '../../config';

export const SET_ACCOUNT_STATS = 'SET_ACCOUNT_STATS';
export const UPDATE_ACCOUNT_STATS = 'UPDATE_ACCOUNT_STATS';
export const STOP_UPDATING_ACCOUNT_STATS = 'STOP_UPDATING_ACCOUNT_STATS';

function setAccountStats(account, properties, rc, walletHistory) {
  return {
    type: SET_ACCOUNT_STATS,
    account: account,
    properties: properties,
    walletHistory: walletHistory,
    rc: rc
  };
}

function updateAccountStats() {
  return {
    type: UPDATE_ACCOUNT_STATS,
  };
}

function stopUpdatingAccountStats() {
  return {
    type: STOP_UPDATING_ACCOUNT_STATS,
  };
}

export const fetchAccountStats = (username) => {
  return async (dispatch) => {
    try {

      dispatch(updateAccountStats());
      const [account] = await Hive.api.getAccountsAsync([username]);
      const properties = await Hive.api.getDynamicGlobalPropertiesAsync();
      const rcPct = await getCurrentResourceCredits(username);
      const { hbd, hive, hive_power, savings_hbd, savings_hive } = await getWalletHistory(username);

      dispatch(setAccountStats(account, properties, rcPct, {hbd, hive, hive_power, savings_hbd, savings_hive}));

    } catch (error) {
      dispatch(stopUpdatingAccountStats());
      console.log(error);
    }
  }
}


const getCurrentResourceCredits = async (username) => {

  try {
    const { data } = await Axios.get(`${config.API_ADDR}/account/${username}/rc`);

    const { max_rc, rc_manabar: { current_mana, last_update_time } } = data.result;
    const CURRENT_UNIX_TIMESTAMP = parseInt((new Date().getTime() / 1000).toFixed(0))
    const elapsed = CURRENT_UNIX_TIMESTAMP - last_update_time;
    let currentMana = parseFloat(current_mana) + elapsed * max_rc / 432000;

    if (currentMana > max_rc) {
        currentMana = max_rc;
    }

    const currentManaPerc = currentMana * 100 / max_rc;

    return currentManaPerc;

  } catch (error) {
    console.log(error);
  }

}

const getWalletHistory = async (username) => {
  try {
    const { data } = await Axios.get(`${config.API_ADDR}/account/${username}/wallet/history`);
    return data;
  } catch (error) {
    console.log(error);
  }
}
